import $ from "jquery";

$(".hotspot").each(function () {
  let $self = $(this);
  let trigger_id = Number($($self).find(".pulse-button").html());

  // console.log(trigger_id);
  $self.on("click", function () {
    if (!$self.hasClass("active")) {
      toggleHotspotItem(trigger_id);
      $self.addClass("active");
    } else {
      removeAllActive();
    }
  });
});

function toggleHotspotItem(id: Number) {
  let $content = $(`#hotspot-content-${id}`);
  let $img = $(`.hotspot__item--${id}`);

  removeAllActive();

  $($content).addClass("active");
  $($img).addClass("active");
}

function removeAllActive() {
  $(".hotspot").each(function () {
    $(this).removeClass("active");
  });

  $(".hotspot__content").each(function () {
    $(this).removeClass("active");
  });

  $(".hotspot__item").each(function () {
    $(this).removeClass("active");
  });
}
